import { useState } from 'react';

import Tracker from '~/src/common/services/Tracker';

const useSearchAnalytics = () => {
  const [isSent, setSent] = useState(false);

  const handleSendEvent = () => {
    if (!isSent) {
      Tracker.sendEvent('shipping type started', {
        'shipping type': 'delivery',
        'shipping type step': 'enter the address',
        'event source': 'navigation',
      });

      setSent(true);
    }
  };

  return { handleSendEvent };
};

export default useSearchAnalytics;
